import { render, staticRenderFns } from "./SettingsPrograms.vue?vue&type=template&id=0e7cd5a4&scoped=true&"
import script from "./SettingsPrograms.vue?vue&type=script&lang=ts&"
export * from "./SettingsPrograms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7cd5a4",
  null
  
)

export default component.exports